import { render, staticRenderFns } from "./salaryApproval.vue?vue&type=template&id=1970ad24&scoped=true&"
import script from "./salaryApproval.vue?vue&type=script&lang=js&"
export * from "./salaryApproval.vue?vue&type=script&lang=js&"
import style0 from "./salaryApproval.vue?vue&type=style&index=0&id=1970ad24&prod&lang=scss&scoped=true&"
import style1 from "./salaryApproval.vue?vue&type=style&index=1&id=1970ad24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970ad24",
  null
  
)

export default component.exports